import React, { ReactNode } from 'react';
import { ApButtonLink } from '@alixpartners/ui-components';

import {
  ContentBlock,
  CostLabel,
  CostValue,
  Description,
  RightSection,
  RightSectionColumn,
  Title,
} from '../../EnvironmentSetup/EnvironmentSetup.styles';
import { AzureDevOpsSectionWrapper } from '../BackEndAccess.styles';

interface IProps {
  label: string;
  requestUrl: string;
  animationIndex: number;
  description: string | ReactNode;
}

export const RequestAzureDevOps = ({
  label,
  animationIndex,
  description,
  requestUrl,
}: IProps) => {
  return (
    <AzureDevOpsSectionWrapper animationIndex={animationIndex}>
      <Title>{label}</Title>
      <ContentBlock>
        <Description>{description}</Description>
        <RightSection>
          <RightSectionColumn>
            <CostValue>
              <ApButtonLink
                target="_blank"
                href={requestUrl}
                rel="noopener noreferrer"
              >
                Request Azure DevOps
              </ApButtonLink>
            </CostValue>
            <CostLabel>from ETS</CostLabel>
          </RightSectionColumn>
        </RightSection>
      </ContentBlock>
    </AzureDevOpsSectionWrapper>
  );
};
